import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { ExportsPaginationTable } from 'backoffice/payments/_components';

const PaymentsExportsPage = () => (
  <ExportsPaginationTable captionSlug="listOfPaymentExports" exportsType="payment_export" />
);

export default compose(withRouter)(PaymentsExportsPage);
export { PaymentsExportsPage };
